import React from "react";
import { useState, useEffect } from "react";
import axios from "./axios";
import "./Row.css";
import YouTube from "react-youtube";
import movieTrailer from "movie-trailer";

const baseurl = "https://image.tmdb.org/t/p/original/";

function Rows({ title, fetchUrL, islargeRow }) {
  const [Movies, setMovies] = useState([]);
  const [trailerUrl, settrailerUrl] = useState("");
  useEffect(() => {
    async function fetchdata() {
      const request = await axios.get(fetchUrL);
      setMovies(request.data.results);
      return request;
    }
    fetchdata();
  }, [fetchUrL]);
  const opts = {
    height: "390",
    width: "100%",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
    },
  };

  const handelclick = (Movies) => {
    if (trailerUrl) {
      settrailerUrl("");
    } else {
      movieTrailer(Movies?.title || "")
        .then((url) => {
          const urlParams = new URLSearchParams(new URL(url).search);
          settrailerUrl(urlParams.get("v"));
        })
        .catch((error) => console.log(error));
    }
  };

  return (
    <div className="row">
      <h2>{title}</h2>
      <div className="row_poster">
        {Movies.map((Movies) => (
          <img
            key={Movies.id}
            onClick={() => handelclick(Movies)}
            className={`row_posters ${islargeRow && "row_posterlarge"}`}
            src={`${baseurl}${
              islargeRow ? Movies.poster_path : Movies.poster_path
            }`}
            alt={Movies.title}
          />
        ))}
      </div>
      {trailerUrl && <YouTube videoId={trailerUrl} opts={opts} />}
    </div>
  );
}

export default Rows;
